<template>
  <div class="container">
    <h2>Error</h2>
  </div>
</template>

<script>
export default {
  name: 'Error',
}
</script>
